import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Avatar } from 'components/common';

// Links a customer cell to its detail page. `withAvatar` leads the cell with
// the company mark (uploaded logo, else neutral initials avatar) — the same
// visual anchor the project list uses for company parties.
const CustomerLink = ({ value, data, withAvatar = false }) => {
  if (!data?.id || !value) return value || null;

  const link = (
    <Link to={`/crm/customers/${data.id}`} className="tw-truncate">
      {value}
    </Link>
  );

  if (!withAvatar) return link;

  return (
    <span className="tw-inline-flex tw-items-center tw-gap-2 tw-max-w-full">
      <Avatar src={data.logo_url || undefined} name={value} alt={value} size="xs" className="tw-shrink-0" />
      {link}
    </span>
  );
};

CustomerLink.propTypes = {
  value: PropTypes.node,
  data: PropTypes.object,
  withAvatar: PropTypes.bool
};

export default CustomerLink;
